// extracted by mini-css-extract-plugin
export var component = "ModularityArea-module--component--wRSVh";